function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 15.0303C3 15.5225 3.38672 15.9795 4.03125 15.9795C4.34766 15.9795 4.61719 15.8037 4.86328 15.6045L15.9258 6.32324C16.1953 6.08887 16.5117 6.08887 16.7812 6.32324L27.832 15.6045C28.0781 15.8037 28.3477 15.9795 28.6641 15.9795C29.2383 15.9795 29.6836 15.6279 29.6836 15.0654C29.6836 14.7139 29.5664 14.4561 29.3086 14.2451L26.2031 11.6318V7.14355C26.2031 6.65137 25.8867 6.33496 25.3945 6.33496H24.0938C23.6133 6.33496 23.2852 6.65137 23.2852 7.14355V9.18262L17.7656 4.55371C16.8984 3.81543 15.8203 3.81543 14.9414 4.55371L3.38672 14.2451C3.12891 14.4678 3 14.749 3 15.0303ZM6.51562 24.9443C6.51562 26.5029 7.46484 27.4287 9.04688 27.4287H23.6484C25.2305 27.4287 26.1914 26.5029 26.1914 24.9443V16.2842L17.0156 8.59668C16.5938 8.2334 16.0898 8.24512 15.668 8.59668L6.51562 16.2842V24.9443ZM19.2188 25.542H13.4766V18.2998C13.4766 17.7842 13.8164 17.4443 14.332 17.4443H18.375C18.8906 17.4443 19.2188 17.7842 19.2188 18.2998V25.542Z",
  fill: "#D5D7DE"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.37099b7c.svg";
export { ForwardRef as ReactComponent };